import { API_URLS } from "../apiUrls";

export const brandReportUnitTestConstants = {
  // Page titles and labels
  KEY_INSIGHTS: /Key Insights/i,
  BEST_CHANNEL: /Best Channel/i,
  TOTAL_SURVEYS: /Total Surveys/i,
  ACTIVE_CHANNEL: /Active Channel/i,
  POSITIVE_RESPONSE: /Positive Response/i,
  OVERALL_COMPLETION: /Overall Completion/i,

  // Descriptions
  COMPLETION_RATE: "Completion rate",
  TOTAL_SENT_VIA_POS: /Total sent via POS/i,
  OF_COMPLETED_SURVEYS: /Of completed surveys/i,
  TOTAL_SENT_VIA_ONLINE: /Total sent via Online/i,
  PRIMARY_FEEDBACK_SOURCE: /Primary feedback source/i,
  AVERAGE_COMPLETION_RATE: /Average completion rate/i,
  COMPLETION_RATES_SAME: "Completion rates are the same.",
  COMBINED_ACROSS_BOTH_CHANNELS: /Combined across both channels/i,

  // Section titles
  POS_SECTION: "POS",
  ONLINE_SECTION: "ONLINE",
  TOTAL_SENT: /TOTAL SENT/i,
  COMPLETION_TYPE_BREAKDOWN: /Completion Type Breakdown/i,

  // Progress card labels
  SURVEYS_OPENED: "Surveys Opened",
  SURVEYS_STARTED: /Surveys Started/i,
  SURVEYS_COMPLETED: /Surveys Completed/i,

  // Breakdown labels
  PASSIVE: /Passive/i,
  POSITIVE: "Positive",
  NEGATIVE: /Negative/i,
  REDIRECT_TO_GOOGLE_REVIEW: /Redirect to Google Review/i,

  // UI Elements
  REFRESH: /Refresh/i,
  SEARCH_BRANDS: /Search Brands/i,
  SELECTED_DATE: /Selected date/i,
  NO_DATA_MESSAGE: /No data available for POS or Online channels/i,
  PLEASE_SEARCH_BRAND: /Please search a brand to view the report/i,

  // Brand IDs for testing
  TEST_BRAND_ID_10304: 10304,
  TEST_BRAND_ID_10257: 10257,
  TEST_BRAND_ID_10246: 10246,
  TEST_BRAND_ID_10255: 10255,

  // Brand names
  TEST_BRAND: "Test brand",
  OLD_SHAWNEE_PIZZA: "Old Shawnee Pizza",
  TEST_MENUFY_BRAND: "TestMenufyBrand071124_1",
  TEST_AUTOMATION_BRAND: "Test Automation Brand",

  // API Endpoints
  GET_SURVEY_REPORT_FOR_POS_AND_ONLINE_STORES:
    API_URLS.USER_RESPONSES.GET_SURVEY_REPORT_FOR_POS_AND_ONLINE_STORES,
  BRAND_STORES: API_URLS.BRAND.STORES,

  // Test IDs - Key Insights
  KEY_INSIGHT_TOTAL_SURVEYS_VALUE: "key-insight-total-surveys-value",
  KEY_INSIGHT_TOTAL_SURVEYS_DESCRIPTION: "key-insight-total-surveys-description",
  KEY_INSIGHT_OVERALL_COMPLETION_VALUE: "key-insight-overall-completion-value",
  KEY_INSIGHT_OVERALL_COMPLETION_DESCRIPTION: "key-insight-overall-completion-description",
  KEY_INSIGHT_POSITIVE_RESPONSE_VALUE: "key-insight-positive-response-value",
  KEY_INSIGHT_POSITIVE_RESPONSE_DESCRIPTION: "key-insight-positive-response-description",
  KEY_INSIGHT_BEST_CHANNEL_VALUE: "key-insight-best-channel-value",
  KEY_INSIGHT_BEST_CHANNEL_DESCRIPTION: "key-insight-best-channel-description",
  KEY_INSIGHT_ACTIVE_CHANNEL_VALUE: "key-insight-active-channel-value",
  KEY_INSIGHT_ACTIVE_CHANNEL_DESCRIPTION: "key-insight-active-channel-description",

  // Test IDs - Brand Report Sections
  BRAND_REPORT_SECTION_POS: "brand-report-section-pos",
  BRAND_REPORT_SECTION_POS_TOTAL_SENT: "brand-report-section-pos-total-sent",
  BRAND_REPORT_SECTION_ONLINE: "brand-report-section-online",
  BRAND_REPORT_SECTION_ONLINE_TOTAL_SENT: "brand-report-section-online-total-sent",

  // Test IDs - Progress Cards
  PROGRESS_CARD_SURVEYS_OPENED: "progress-card-surveys-opened",
  PROGRESS_CARD_SURVEYS_OPENED_VALUE: "progress-card-surveys-opened-value",
  PROGRESS_CARD_SURVEYS_OPENED_PERCENTAGE: "progress-card-surveys-opened-percentage",
  PROGRESS_CARD_SURVEYS_STARTED: "progress-card-surveys-started",
  PROGRESS_CARD_SURVEYS_STARTED_VALUE: "progress-card-surveys-started-value",
  PROGRESS_CARD_SURVEYS_STARTED_PERCENTAGE: "progress-card-surveys-started-percentage",
  PROGRESS_CARD_SURVEYS_COMPLETED: "progress-card-surveys-completed",
  PROGRESS_CARD_SURVEYS_COMPLETED_VALUE: "progress-card-surveys-completed-value",
  PROGRESS_CARD_SURVEYS_COMPLETED_PERCENTAGE: "progress-card-surveys-completed-percentage",

  // Test IDs - Breakdown Items
  BREAKDOWN_ITEM_POSITIVE: "breakdown-item-positive",
  BREAKDOWN_ITEM_POSITIVE_VALUE: "breakdown-item-positive-value",
  BREAKDOWN_ITEM_POSITIVE_PERCENTAGE: "breakdown-item-positive-percentage",
  BREAKDOWN_ITEM_PASSIVE: "breakdown-item-passive",
  BREAKDOWN_ITEM_PASSIVE_VALUE: "breakdown-item-passive-value",
  BREAKDOWN_ITEM_PASSIVE_PERCENTAGE: "breakdown-item-passive-percentage",
  BREAKDOWN_ITEM_NEGATIVE: "breakdown-item-negative",
  BREAKDOWN_ITEM_NEGATIVE_VALUE: "breakdown-item-negative-value",
  BREAKDOWN_ITEM_NEGATIVE_PERCENTAGE: "breakdown-item-negative-percentage",
  BREAKDOWN_ITEM_REDIRECT_TO_GOOGLE_REVIEW: "breakdown-item-redirect-to-google-review",
  BREAKDOWN_ITEM_REDIRECT_TO_GOOGLE_REVIEW_VALUE: "breakdown-item-redirect-to-google-review-value",
  BREAKDOWN_ITEM_REDIRECT_TO_GOOGLE_REVIEW_PERCENTAGE: "breakdown-item-redirect-to-google-review-percentage",

  // Expected Values - Test Automation Brand (Dual Channel)
  // Key Insights
  EXPECTED_TOTAL_SURVEYS_DUAL_CHANNEL: "174",
  EXPECTED_BEST_CHANNEL_VALUE: "Online",
  EXPECTED_OVERALL_COMPLETION_PATTERN_DUAL: /67\.\d+%/, // Matches 67.24% or similar
  EXPECTED_POSITIVE_RESPONSE_PATTERN_DUAL: /48\.\d+%/, // Matches 48.72% or similar
  EXPECTED_BEST_CHANNEL_DESCRIPTION_PATTERN: /73\.\d+% higher completion rate/,

  // POS Section - Test Automation Brand
  EXPECTED_POS_TOTAL_SENT: "14",
  EXPECTED_POS_OPENED_VALUE: "14",
  EXPECTED_POS_OPENED_PERCENTAGE: "100%",
  EXPECTED_POS_STARTED_VALUE: "13",
  EXPECTED_POS_STARTED_PERCENTAGE: "92.86%",
  EXPECTED_POS_COMPLETED_VALUE: "0",
  EXPECTED_POS_COMPLETED_PERCENTAGE: "0%",
  EXPECTED_POS_POSITIVE_VALUE: "0",
  EXPECTED_POS_POSITIVE_PERCENTAGE: "0%",
  EXPECTED_POS_PASSIVE_VALUE: "0",
  EXPECTED_POS_PASSIVE_PERCENTAGE: "0%",
  EXPECTED_POS_NEGATIVE_VALUE: "0",
  EXPECTED_POS_NEGATIVE_PERCENTAGE: "0%",
  EXPECTED_POS_GOOGLE_REVIEW_VALUE: "0",
  EXPECTED_POS_GOOGLE_REVIEW_PERCENTAGE: "0%",

  // Online Section - Test Automation Brand
  EXPECTED_ONLINE_TOTAL_SENT_DUAL: "160",
  EXPECTED_ONLINE_OPENED_VALUE_DUAL: "160",
  EXPECTED_ONLINE_OPENED_PERCENTAGE_DUAL: "100%",
  EXPECTED_ONLINE_STARTED_VALUE_DUAL: "147",
  EXPECTED_ONLINE_STARTED_PERCENTAGE_DUAL: "91.88%",
  EXPECTED_ONLINE_COMPLETED_VALUE_DUAL: "117",
  EXPECTED_ONLINE_COMPLETED_PERCENTAGE_DUAL: "73.13%",
  EXPECTED_ONLINE_POSITIVE_VALUE_DUAL: "57",
  EXPECTED_ONLINE_POSITIVE_PERCENTAGE_DUAL: "48.72%",
  EXPECTED_ONLINE_PASSIVE_VALUE_DUAL: "40",
  EXPECTED_ONLINE_PASSIVE_PERCENTAGE_DUAL: "34.19%",
  EXPECTED_ONLINE_NEGATIVE_VALUE_DUAL: "20",
  EXPECTED_ONLINE_NEGATIVE_PERCENTAGE_DUAL: "17.09%",
  EXPECTED_ONLINE_GOOGLE_REVIEW_VALUE_DUAL: "0",
  EXPECTED_ONLINE_GOOGLE_REVIEW_PERCENTAGE_DUAL: "0%",

  // Expected Values - Old Shawnee Pizza (Single Channel)
  // Key Insights
  EXPECTED_TOTAL_SURVEYS_SINGLE_CHANNEL: "25",
  EXPECTED_OVERALL_COMPLETION_SINGLE: "75%",
  EXPECTED_POSITIVE_RESPONSE_PATTERN_SINGLE: /53\.\d+%/, // Matches 53.33% or similar
  EXPECTED_ACTIVE_CHANNEL_VALUE: "Online",
  EXPECTED_ACTIVE_CHANNEL_DESCRIPTION: "Primary feedback source",

  // Online Section - Old Shawnee Pizza
  EXPECTED_ONLINE_TOTAL_SENT_SINGLE: "25",
  EXPECTED_ONLINE_OPENED_VALUE_SINGLE: "20",
  EXPECTED_ONLINE_OPENED_PERCENTAGE_SINGLE: "80%",
  EXPECTED_ONLINE_STARTED_VALUE_SINGLE: "18",
  EXPECTED_ONLINE_STARTED_PERCENTAGE_SINGLE: "72%",
  EXPECTED_ONLINE_COMPLETED_VALUE_SINGLE: "15",
  EXPECTED_ONLINE_COMPLETED_PERCENTAGE_SINGLE: "60%",
  EXPECTED_ONLINE_POSITIVE_VALUE_SINGLE: "8",
  EXPECTED_ONLINE_POSITIVE_PERCENTAGE_SINGLE: "53.33%",
  EXPECTED_ONLINE_PASSIVE_VALUE_SINGLE: "3",
  EXPECTED_ONLINE_PASSIVE_PERCENTAGE_SINGLE: "20%",
  EXPECTED_ONLINE_NEGATIVE_VALUE_SINGLE: "4",
  EXPECTED_ONLINE_NEGATIVE_PERCENTAGE_SINGLE: "26.67%",
  EXPECTED_ONLINE_GOOGLE_REVIEW_VALUE_SINGLE: "2",
  EXPECTED_ONLINE_GOOGLE_REVIEW_PERCENTAGE_SINGLE: "13.33%",

  // Expected Counts
  EXPECTED_DUAL_CHANNEL_LABEL_COUNT: 2, // Labels appear twice (POS and Online sections)
  EXPECTED_MINIMUM_TOTAL_SENT_LABELS: 2, // Minimum labels for dual channel scenario
};